export default __webpack_public_path__ + "static/media/arrow.31284533.svg";